import { render, staticRenderFns } from "./rkFix.vue?vue&type=template&id=0b6a531c&scoped=true"
import script from "./rkFix.vue?vue&type=script&lang=js"
export * from "./rkFix.vue?vue&type=script&lang=js"
import style0 from "./rkFix.vue?vue&type=style&index=0&id=0b6a531c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6a531c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b6a531c')) {
      api.createRecord('0b6a531c', component.options)
    } else {
      api.reload('0b6a531c', component.options)
    }
    module.hot.accept("./rkFix.vue?vue&type=template&id=0b6a531c&scoped=true", function () {
      api.rerender('0b6a531c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/rkFix.vue"
export default component.exports